import React, { Component } from 'react'
import moment from 'moment';
import status from 'http-status';
import Confirm from './Confirm';
import Schedule from './Schedule';
import SelectGroups from './SelectGroups';
import VaccineDetails from './VaccineDetails';
import { connect } from 'react-redux';
import { history } from '../../../_helpers/history';
import { alertActions } from '../../../_actions/alert.actions';
import { vaccineScheduleService } from '../../../_services/vaccine-schedule.service';

class CreateSchedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      errors: [],
      invalid: '',
      loading: false,
      currentStep: 'SCHEDULE',
    }

    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleBackStep = this.handleBackStep.bind(this);
    this.handleScheduleData = this.handleScheduleData.bind(this);
    this.handleCreateSchedule = this.handleCreateSchedule.bind(this);
  }

  handleNextStep() {
    let nextStep;

    switch (this.state.currentStep) {
      case 'SCHEDULE':
        nextStep = 'VACCINE_DETAILS';
        break;
      case 'VACCINE_DETAILS':
        nextStep = 'SELECT_GROUPS';
        break;
      case 'SELECT_GROUPS':
        nextStep = 'CONFIRM';
        break;
      default:
        return false;
    }

    this.setState({ currentStep: nextStep });
  }

  handleBackStep() {
    let nextStep;

    switch (this.state.currentStep) {
      case 'CONFIRM':
        nextStep = 'SELECT_GROUPS';
        break;
      case 'SELECT_GROUPS':
        nextStep = 'VACCINE_DETAILS';
        break;
      case 'VACCINE_DETAILS':
        nextStep = 'SCHEDULE';
        break;
      default:
        return false;
    }

    this.setState({ currentStep: nextStep });
  }

  handleScheduleData(newData) {
    this.setState(prevState => { return { data: { ...prevState.data, ...newData } } },
      () => { this.handleNextStep(); });
  }

  handleCreateSchedule() {
    this.setState({ loading: true });

    const {
      vaccine,
      startTime,
      endTime,
      timeSlot,
      perTimeSlot,
      stations,
      location,
      provider,
      groups,
      firstAppt,
      secondAppt,
      firstQuestionnaire,
      secondQuestionnaire,
      adverseDate,
      adverseQuestionnaire,
      adverseLocation,
      adverseProvider
    } = this.state.data;

    const data = {
      vaccineType: vaccine,
      startTime: moment(startTime).format('YYYY-MM-DD HH:mm'),
      endTime: moment(endTime).format('YYYY-MM-DD HH:mm'),
      timeSlot: timeSlot,
      perTimeSlot: perTimeSlot,
      stations: stations,
      location: location.value,
      provider: provider.value,
      groups: groups,
      firstAppointment: moment(firstAppt).format('YYYY-MM-DD'),
      firstQuestionnaire: firstQuestionnaire.value,
      secondAppointment: vaccine !== "janssen" ? moment(secondAppt).format('YYYY-MM-DD') : '',
      secondQuestionnaire: vaccine !== "janssen" ? secondQuestionnaire.value : '',
      adverseCompleteBy: moment(adverseDate).format('YYYY-MM-DD'),
      adverseQuestionnaire: adverseQuestionnaire.value,
      adverseLocation: adverseLocation.value,
      adverseProvider: adverseProvider.value,
    }

    vaccineScheduleService.create(data)
      .then((response) => {
        this.setState({ loading: false });

        history.push('/vaccine/schedule');
        this.props.dispatch(alertActions.success('Schedule Created!'));

      })
      .catch(error => {
        this.setState({ loading: false });

        if (error.response && error.response.status === status.UNPROCESSABLE_ENTITY) {
          this.setState({ invalid: error.response.data.errors })
        } else {
          this.props.dispatch(alertActions.error('Could not create the schedule at this time. Please try again later.'));
        }
      })
  }

  render() {
    const { currentStep } = this.state;

    return (
      <div className="row">
        <div className="col-lg-12">
          <Schedule
            currentStep={currentStep}
            handleData={this.handleScheduleData}
          />

          <VaccineDetails
            data={this.state.data}
            backStep={this.handleBackStep}
            handleData={this.handleScheduleData}
            currentStep={currentStep}
          />

          <SelectGroups
            data={this.state.data}
            nextStep={this.handleNextStep}
            backStep={this.handleBackStep}
            handleData={this.handleScheduleData}
            currentStep={currentStep}
          />

          <Confirm
            data={this.state.data}
            loading={this.state.loading}
            backStep={this.handleBackStep}
            currentStep={currentStep}
            handleCreateSchedule={this.handleCreateSchedule} />
        </div>
      </div>
    )
  }
}

export default connect()(CreateSchedule);